<template lang="pug">
.Reports(v-if='workspace && version')
  app-header
    b.Menu-title ОТЧЕТЫ
  .Reports-menu.Menu
    .Menu-left
      .Menu-item
        label
          input(
            type='checkbox',
            @change='selectAll',
            :checked='availableList.length === selectedCount'
          )
          span Выбрать все
    .Menu-right
      .Menu-item
        span Выбрано
        b {{ selectedCount }}

      .Menu-delimiter
      .Menu-item.Menu-link
        a.Pointer(@click='downloadSelected')
          i.Icon.IconDownload
          span скачать выбранные
      .Menu-delimiter
      .Menu-item.Menu-link
        a.Pointer(@click='downloadAll') скачать все
  .Reports-main
    .Reports-spinner
      fade-loader.Spinner(
        :loading='isLoading || isInitLoading',
        color='#27bd8a',
        height='8px',
        width='3px',
        radius='10px'
      )
    .CommonTabs
      template(v-for='group in Object.keys(reportGroups)')
        .CommonTabs-item(
          v-if='reportGroups[group].length > 0',
          @click='selectTab(group)',
          :class='{ "CommonTabs-item--active": group === selectedTab }'
        )
          | {{ group }}
          sup.CommonTabs-sup {{ reportGroups[group].length }}

    .Reports-list(v-if='!isInitLoading && !isLoading && list.length > 0')
      report-item.Reports-item.Card(
        v-for='item in reportGroups[selectedTab]',
        :isSelected='isSelectedMap[item.techName]',
        :key='item.techName',
        :item='item',
        :isSelectable='true',
        :isDownloading='downloadingDocs[item.techName]',
        @changeWorkspaceDiff='changeWorkspaceDiff(item, $event)',
        @generate='generateItem(item)',
        @toggleSelect='toggleSelect(item)'
      )
    .Reports-empty(v-if='!isInitLoading && !isLoading && list.length === 0') Список отчетов пуст
</template>

<script>
import Vue from 'vue'
import { DateTime } from 'luxon'
import { convertArrayToObject } from '../helpers/utils'

export default {
  name: 'Reports.vue',
  components: {
    'app-header': () => import('@/components/AppHeader'),
    'fade-loader': () => import('vue-spinner/src/FadeLoader.vue'),
    'custom-select': () => import('@/components/CustomSelect'),
    'report-item': () => import('@/components/reports/ReportItem')
  },
  computed: {
    workspaceList() {
      const existedWorkspace = this.$store.getters.activeWorkspaceList
        ? this.$store.getters.activeWorkspaceList
            .filter((v) => v.id !== this.workspace)
            .map((v) => {
              return {
                ...v,
                name: 'Рабочим пространством №' + v.id
              }
            })
        : []
      return [{ id: 0, name: 'Рабочее пространство не выбрано' }].concat(existedWorkspace)
    },
    list() {
      return this.$store.getters.reportsList.map((v) => {
        return {
          ...v,
          techName: v.name,
          name: v.name.indexOf('_') > -1 ? v.description || this.namesMap[v.name] : v.name,
          date: v.created
            ? DateTime.fromFormat(v.created, 'dd MMM yyyy TT', {
                zone: 'utc'
              })
                .toLocal()
                .toFormat('dd.MM.yyyy HH:mm')
            : '',
          comparesMap: v.compares
            ? convertArrayToObject(
                v.compares.map((item) => {
                  return {
                    ...item,
                    techName: item.name,
                    name: item.name.indexOf('_') > -1 ? item.description || this.namesMap[item.name] : item.name,
                    date: item.created
                      ? DateTime.fromFormat(item.created, 'dd MMM yyyy TT', {
                          zone: 'utc'
                        })
                          .toLocal()
                          .toFormat('dd.MM.yyyy HH:mm')
                      : '',
                    workspace_diff: item.workspace_diff || this.workspace
                  }
                }),
                'workspace_diff'
              )
            : null
        }
      })
    },
    reportGroups() {
      if (!this.list) return null
      const groups = Array.from(new Set(this.list.map((v) => v.category))).reduce((groups, group) => {
        groups[group] = this.list.filter((v) => v.category === group && v.display_in_reports)
        return groups
      }, {})
      if (!this.selectedTab) this.selectedTab = Object.keys(groups)[0] || ''
      return groups
    },
    haveUnavailableItems() {
      return this.availableList.length < this.list.length
    },
    availableList() {
      return this.list.filter(
        (v) =>
          v.file ||
          (v.compares &&
            this.reportParams[v.techName] &&
            v.comparesMap[this.reportParams[v.techName].workspaceDiff] &&
            v.comparesMap[this.reportParams[v.techName].workspaceDiff].file)
      )
    },
    selectedCount() {
      return Object.keys(this.isSelectedMap).length
    },
    isInitLoading() {
      return this.$store.getters.isInitLoading
    },
    workspace() {
      return this.$store.getters.workspace
    },
    version() {
      return this.$store.getters.version
    },
    workspaceAndVersion() {
      return { workspace: this.workspace, version: this.version }
    }
  },
  watch: {
    haveUnavailableItems(newVal) {
      if (newVal) {
        this.startRegularRequests()
      } else {
        this.clearRegularRequests()
      }
    },
    workspaceAndVersion(newVal, oldVal) {
      if (oldVal.workspace && newVal.workspace !== oldVal.workspace) {
        this.$store.dispatch('clearReports')
      } else if (oldVal.version && oldVal.version !== newVal.version) {
        this.$store.dispatch('clearReports')
      }
      this.isSelectedMap = {}
      this.reportParams = {}
      this.selectedTab = ''
      this.getList()
    }
  },
  beforeDestroy() {
    this.$store.dispatch('clearReports')
    this.clearRegularRequests()
  },
  data() {
    return {
      downloadingDocs: {},
      isSelectedMap: {},
      reportParams: {},
      regularListUpdate: null,
      isLoading: false,
      selectedTab: '',
      namesMap: {
        export_summary: 'Сводная выгрузка',
        export_summary_infrastructure: 'Сводная выгрузка: лист показателей объектов',
        export_summary_flow_ext: 'Сводная выгрузка: лист расширенной информации по потокам',
        export_summary_flow_stat: 'Сводная выгрузка: лист статистики по потокам',
        export_summary_flow_type: 'Сводная выгрузка: лист данных потоков по видам объектов'
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    selectTab(group) {
      this.selectedTab = group
    },
    startRegularRequests() {
      this.clearRegularRequests()
      this.regularListUpdate = setInterval((v) => {
        this.$store.dispatch('getReportsList')
      }, 60000)
    },
    clearRegularRequests() {
      clearInterval(this.regularListUpdate)
    },
    getList() {
      if (this.workspace && this.version) {
        this.isLoading = true
        this.$store
          .dispatch('getReportsList')
          .then((r) => {
            this.isLoading = false
          })
          .catch((e) => {
            this.isLoading = false
          })
      }
    },
    changeWorkspaceDiff(item, workspaceDiff) {
      this.reportParams = {
        ...this.reportParams,
        [item.techName]: workspaceDiff ? { workspaceDiff } : null
      }
      if (this.isSelectedMap[item.techName]) {
        if (item.comparesMap[workspaceDiff] && item.comparesMap[workspaceDiff].file) {
          Vue.set(this.isSelectedMap, item.techName, item.comparesMap[workspaceDiff].id)
        } else {
          Vue.delete(this.isSelectedMap, item.techName)
        }
      }
    },
    selectAll() {
      if (this.availableList.length !== this.selectedCount) {
        this.availableList.forEach((v) => {
          Vue.set(this.isSelectedMap, v.techName, v.id || v.comparesMap[this.reportParams[v.techName].workspaceDiff].id)
        })
      } else {
        this.availableList.forEach((v) => {
          Vue.delete(this.isSelectedMap, v.techName)
        })
      }
    },
    downloadSelected() {
      const ids = Object.values(this.isSelectedMap).map((v) => parseInt(v))
      if (ids.length > 0) {
        this.download(ids, Object.keys(this.isSelectedMap))
      }
    },
    downloadAll() {
      const selectList = this.list.filter(
        (v) =>
          v.file ||
          (v.compares &&
            this.reportParams[v.techName] &&
            v.comparesMap[this.reportParams[v.techName].workspaceDiff] &&
            v.comparesMap[this.reportParams[v.techName].workspaceDiff].file)
      )
      this.download(
        selectList.map((v) => v.id || v.comparesMap[this.reportParams[v.techName].workspaceDiff].id),
        selectList.map((v) => v.techName)
      )
    },
    generateItem(item) {
      const params = {
        type: item.techName
      }
      if (item.compares) {
        params.workspace_id_2 = this.reportParams[item.techName].workspaceDiff
      }
      this.$store.dispatch('generateReport', [params])
    },
    download(ids, techNames) {
      let name = ''
      if (ids.length === 1) {
        const object = this.list.filter((v) => v.id === ids[0])[0]
        name += object.techName + '.' + (object.extension || 'xlsx')
      }
      const params = {
        ids,
        name
      }
      if (this.workspaceDiff && this.workspaceDiff.id) {
        params['workspace'] = this.workspaceDiff.id
      }
      this.updateDownloadingItems(techNames, true)
      this.$store
        .dispatch('getReportFile', params)
        .then((r) => {
          this.updateDownloadingItems(techNames, false)
        })
        .catch((e) => {
          this.updateDownloadingItems(techNames, false)
          this.$store.commit('setApiErrorInfo', 'Ошибка получения отчета')
        })
    },
    updateDownloadingItems(techNames, state) {
      techNames.forEach((v) => {
        this.downloadingDocs = {
          ...this.downloadingDocs,
          [v]: state
        }
      })
    },
    toggleSelect(item) {
      if (this.isSelectedMap[item.techName]) {
        Vue.delete(this.isSelectedMap, item.techName)
      } else {
        Vue.set(this.isSelectedMap, item.techName, item.id || item.comparesMap[this.reportParams[item.techName].workspaceDiff].id)
      }
    }
  }
}
</script>

<style lang="scss">
@import '~base';

#app .Reports {
  --menuLinkColor: #{$blue};
  --menuColor: #{$grey8};
  --selectedText: #{$black5};
}

#app[data-theme='dark'] .Reports {
  --menuLinkColor: #{$blue};
  --menuColor: #{$grey1};
  --selectedText: #{$grey5};
}
</style>
<style scoped lang="scss">
@import '~base';
.Menu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 35px;
  padding: 0 15px;
  color: var(--menuColor);
  border-bottom: 1px solid var(--delimiter);

  label {
    margin-bottom: 0;
    line-height: 20px;

    span {
      display: block;
    }
  }

  &-label {
    flex: 0 0 auto;
    margin-right: 10px;
  }

  &-left,
  &-right {
    display: flex;
    align-items: center;
  }

  &-left &-item {
    margin-right: 20px;
  }

  &-right &-item,
  &-right &-delimiter {
    margin-left: 20px;
  }

  &-select {
    display: flex;
    align-items: center;

    .Select {
      height: 28px;
    }
  }

  &-item {
    font-size: 12px;

    b {
      margin-left: 7px;
      color: var(--selectedText);
      font-size: 14px;
    }

    a {
      display: flex;
      align-items: center;
      color: var(--menuLinkColor);
      font-size: 11px;
      font-weight: 300;
      text-transform: uppercase;

      .Icon {
        margin-right: 10px;
      }
    }
  }

  &-delimiter {
    width: 1px;
    height: 24px;
    background: var(--delimiter);
  }
}

.Reports {
  display: flex;
  flex-direction: column;
  height: 100%;

  &-menu {
    flex: 0 0 35px;
  }

  &-spinner {
    position: fixed;
    top: 50%;
    left: 50%;
    margin: -16px 0 0 -16px;
  }

  &-empty {
    padding: 15px 0;
    font-size: 14px;
  }
  &-main {
    flex: 1 1 auto;
    background: var(--appBg);
    overflow: auto;
  }
  &-list {
    display: flex;
    padding: 0 15px 50px;
    margin-left: -2%;
    flex-wrap: wrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Reports.vue